import { hasSuperAdminRole } from 'app/shared/utils/super-admin-access.util';
import { Component } from '@angular/core';
import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Subscription } from 'rxjs';

/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the roles passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *appHasAnyRole="'ROLE_VALUE'">...</some-element>
 *
 *     <some-element *appHasAnyRole="['ROLE_VALUE_1', 'ROLE_VALUE_2']">...</some-element>
 * ```
 */
@Directive({
  selector: '[appHasAnyRole]'
})
export class HasAnyAppRoleComponentDirective {

  private roles: string[] = [];

  constructor(private templateRef: TemplateRef<any>, private viewContainerRef: ViewContainerRef) {}

  @Input()
  set appHasAnyRole(value: string | string[]) {
    // check if single role supplied or multiple roles and assign to variable
    this.roles = typeof value === 'string' ? [value] : value;

    // before showing again call to prevent duplicates
    this.updateView();
    
    // Get notified each time authentication state changes
    // replace api with your authentication check    

  }

  private updateView(): void {
    const hasAnyRole = this.checkRole(this.roles); 
    // clear any old reference to prevnt duplication
    this.viewContainerRef.clear();
    // show content if role true, else dont. this is the main logic
    if (hasAnyRole) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
  
  checkRole(roles: string[] | string): boolean {
    return !hasSuperAdminRole();
  }
}
